
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-you",
      function () {
        return require("private-next-pages/for-you/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-you"])
      });
    }
  